import {
  canAccess,
  canPerformAction,
  getAccessibleResources,
  getAllowedActions,
} from '~/utils/rbac';
import type { Action } from '~/types/rbac';

export const useRBAC = () => {
  const canPerform = (resource: string, action: Action): boolean => {
    return canPerformAction(resource, action);
  };

  const hasAccess = (resource: string): boolean => {
    return canAccess(resource);
  };

  const canEdit = (resource: string): boolean => {
    return canPerformAction(resource, 'edit');
  };

  const canDelete = (resource: string): boolean => {
    return canPerformAction(resource, 'delete');
  };

  const canCreate = (resource: string): boolean => {
    return canPerformAction(resource, 'create');
  };

  const accessibleResources = (): string[] => {
    return getAccessibleResources();
  };

  const allowedActions = (resource: string): Action[] => {
    return getAllowedActions(resource);
  };

  return {
    hasAccess,
    canPerform,
    canEdit,
    canDelete,
    canCreate,
    accessibleResources,
    allowedActions,
  };
};
